<template>
    <div>
        <div class="d-flex justify-content-between mb-4">
            <div>
                <h1 class="mb-0" :id="details.id">{{ details.fullname }}</h1>
            </div>
            <div>
                <button
                    type="button"
                    class="btn mr-2"
                    style="background-color: #e1e1e1"
                    :disabled="!details.isactive"
                    @click="cancelClicked"
                >
                    Cancel
                </button>
                <button
                    type="button"
                    class="btn"
                    style="background-color: #180f29; color: white"
                    :disabled="!details.isactive"
                    @click="saveClicked"
                >
                    Save
                </button>
            </div>
        </div>
        <staff-details-form :isEditStaff="true" />
    </div>
</template>

<script>
import StaffDetailsForm from "@/components/setting-staff/staff-details-form.vue";
import staffService from "@/services/staff";
import { get } from "lodash";
import { STAFF_PROFILE_TAB_OPTIONS } from "@/store/staff.js";

export default {
    name: "staffView",
    components: {
        StaffDetailsForm
    },
    computed: {
        staffEncondedId() {
            return this.$route.params.id;
        },
        details() {
            return this.$store.getters["staff/staffDetails"];
        },
        isLoading() {
            return this.$store.getters["staff/isLoadingDetailsForm"];
        }
    },
    data() {
        return {};
    },
    methods: {
        cancelClicked() {
            if (this.isLoading) return;
            this.$store.commit(
                "staff/setStaffProfileTab",
                STAFF_PROFILE_TAB_OPTIONS.profile
            );
        },
        async saveClicked() {
            if (this.isLoading) return;
            this.$store.commit("staff/setIsLoadingDetailsForm", true);

            try {
                const res = await this.$store.dispatch("staff/updateStaff");

                const resCode = get(res, "message.code", null);
                const resMessageError = get(res, "resource.message", "");

                if (resCode && resCode == 200) {
                    let data = await staffService.getStaffDetail(
                        this.staffEncondedId
                    );
                    if (data.status == 200) {
                        this.$store.commit(
                            "staff/setStaffDetails",
                            data.data.response.resource.actor
                        );
                        this.$store.commit(
                            "staff/setStaffProfileTab",
                            STAFF_PROFILE_TAB_OPTIONS.profile
                        );
                    }
                } else if (resMessageError) {
                    this._message(resMessageError, "danger");
                }
            } catch (e) {
                this._message(e.message, "danger");
            }

            this.$store.commit("staff/setIsLoadingDetailsForm", false);
        }
    }
};
</script>
